import type { GeoPoint } from '../location/types';

// all tenants should have a department center. Add a dummy center in case department center is not available. (show Mark43 Headquarter as map center)
export const dummyCenter: GeoPoint = { latitude: 40.7523176, longitude: -73.9826875 };

// useInaccurateLocationCheckInterval will update all units isLocationPotentiallyInaccurate field every x ms.
export const LOCATION_INACCURATE_CHECK_INTERVAL = 60000; // ms

// delay in ms for PromiseBuffer
export const MAP_VIEW_REQUEST_PROMISE_BUFFER_DELAY = 100; // ms

// delay in ms for gps bulk update, unit gps websocket messages received during UNIT_GPS_BULK_UPDATE_DELAY will be updated in bulk.
export const UNIT_GPS_BULK_UPDATE_DELAY = 3000; // ms

// esri map map on change callback throttle threshold in ms.
// when move map fast, we may not need to trigger onMapChange while user is still moving the map.
export const MAP_ON_CHANGE_THROTTLE_THRESHOLD = 100; // ms

// esri map events and units search input debounce. Avoid triggering search on each key stroke
export const MAP_EVENTS_AND_UNITS_SEARCH_INPUT_DEBOUNCE_THRESHOLD = 300; // ms

// map entity details max agencies to display in the map ledger
export const MAX_AGENCIES_TO_SHOW = 3;

export const DELAY_FOR_UNIT_UPDATE = 2000;
export const DELAY_FOR_USER_UPDATE = 1000;

export const CAD_MAP_FILTERS_LOCAL_STORAGE_KEY = 'cad.map.filters';
export const FR_MAP_FILTERS_LOCAL_STORAGE_KEY = 'first-responder.map.filters';
export const MAP_LAYERS_LOCAL_STORAGE_KEY = 'map.layers';
